import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';

function DynamicPageTitle() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    let title = 'BespokeBridge';

    if (path.includes('/superadmin')) {
      title = 'SuperAdmin | BespokeBridge';
    } else if (path.includes('/admin/login')) {
      title = 'Admin Login | BespokeBridge';
    } else if (path.includes('/admin/core')) {
      title = 'Core Settings | BespokeBridge';
    } else if (path.includes('/admin/programmes')) {
      title = 'Programmes | BespokeBridge';
    } else if (path.includes('/admin/community')) {
      title = 'Community | BespokeBridge';
    } else if (path.includes('/admin/communications')) {
      title = 'Communications | BespokeBridge';
    } else if (path.includes('/admin/events')) {
      title = 'Events | BespokeBridge';
    } else if (path.includes('/admin/reports')) {
      title = 'Reports | BespokeBridge';
    } else if (path.includes('/admin/ai')) {
      title = 'BespokeAI | BespokeBridge';
    } else if (path.includes('/admin')) {
      title = 'Admin Portal | BespokeBridge';
    }

    document.title = title;
  }, [location]);

  return null;
}

export default DynamicPageTitle;
